import Navbar from "../components/navbar/Navbar";
import COTAnalysis from "../components/COT-analysis/COTAnalysis";
import RootView from "../components/COT-analysis/RootDetails";
import { useParams, useNavigate } from "react-router-dom";
import AgGridGrid from "../components/COT-analysis/AgGrid/AgGridGrid";
// import NavbarTabs from "../components/navbar-tabs/NavbarTabs";

// import Plot from "react-plotly.js";

function COTAnalysisScreen() {
  const { root } = useParams<{ root?: string }>();
  const navigate = useNavigate();

  return (
    <div className="container-fluid bg-theme" style={{ height: "100vh" }}>
      <div className="row h-100">
        {root == null ? (
          <div className="d-flex flex-column h-100" style={{ minHeight: 0 }}>
            <div className="w-100 mb-2 flex-shrink-0">
              <Navbar />
            </div>
            <div className="flex-grow-1 px-2" style={{ minHeight: 0 }}>
              <AgGridGrid />
            </div>
          </div>
        ) : (
          <div>
            <div className="w-100 mb-2">
              <Navbar />
              </div>
              <RootView
                root={root}
                onClose={() => navigate("/COT-analysis")}
              />
            </div>
        )}
      </div>
    </div>
  );
}

export default COTAnalysisScreen;
